import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_40e71bc7: FaireBrandEntity = {
  token: "b_40e71bc7",
  type: "brand",
  name: "HomArt",
  avatarUrl:
    "https://cdn.faire.com/fastly/fdf7ee285a2df5d9a279fe53decc533f1d97f0f999a8f642e92ea75cd43e91e6.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/9535510d62a485de1ce29f63171876bb56e8bef672203b8ddf5efa1f904384ba.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/fdf7ee285a2df5d9a279fe53decc533f1d97f0f999a8f642e92ea75cd43e91e6.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9535510d62a485de1ce29f63171876bb56e8bef672203b8ddf5efa1f904384ba.jpeg",
  location: "Irvine, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.7,
  reviewCount: 1047,
  isTopShop: true,
  isInsider: true,
  description:
    "Inspired by California living and architecture, HomArt® presents a collection of hand finished home accessories forging a contemporary link with California's romantic past.\nThis exclusive range of refined yet affordable home accessories is created for everyday use from all-natural, recycled, and new materials, simple and tastefully designed to comfortably mix with any décor. Showing the handwork of skilled craftsmen, the HomArt® collection evokes the warmth and serenity of a less hurried era.\n",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:36:57.514Z",
    importedBy: "entity-db-cli",
  },
};
